module.exports = __webpack_public_path__ + "img/view-rain.48721c65.png";